<template>
  <div style="padding: 310px 80px 0 80px">
    <el-row :gutter="60">
      <el-col :span="24" class="card-01">
        <el-row :gutter="20">
          <el-col :span="24" class="modal_title middle_blue">
            Vítejte
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12" style="border-right: 3px dotted #bad2ff;">
            <p class="wel"><span class="title">NEON</span> je databázový systém, který vznikl pro potřeby neuroonkologického centra.</p>
            <p class="wel"><span class="title">NEON</span> je vytvořen jako modulární systém, kde je každý modul připraven pro potřeby dané odbornosti (neurochirurg, onkolog, patolog a další).</p>
            <p class="wel">Tento modulární systém umožňuje lépe reflektovat specifika jednotlivých odborností věnujících se dětským pacientům s nádory CNS.</p>
          </el-col>
          <el-col :span="12" style="padding-left: 40px">
            <p class="wel">Zároveň integrace dat z jednotlivých modulů umožní velmi rychle připravit potřebná data k odpovědi na otázky, které si neuroonkologické centrum položí.</p>
            <p class="wel">Analýza získaných dat také přinese nové podněty pro budoucí studie.</p>
            <p class="wel">Systém je vytvářen ve spolupráci s bioinformatickou firmou BIOXSYS s.r.o.</p>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

  export default {
    components: {

    },

    data () {
      return {

      }
    },

    computed: {
      ...mapState({
        token: state => state.token,
      }),

      ...mapGetters({
      }),

    },

    methods: {
      ...mapMutations({
      }),

      ...mapActions({
        a_login_hash: 'a_login_hash',
      }),


      onSubmit() {
        console.log('submit!');
      },


      change_inco(value) {
        console.log(value);
      },
    },


    beforeCreate () {
    },

    created () {
    },

    beforeMount () {
    },

    mounted () {

    },

    beforeUpdate () {
    },

    updated () {

    },

    afterDestroy () {
    },

    destroyed () {
    },


    beforeRouteEnter(to, from, next) {
        next( vm => {
        console.log(to);
        if (to.params.myhash !== undefined && to.params.myhash.length > 0) {
          vm.a_login_hash( { myhash: to.params.myhash } );
        }
      });
    },

  }
</script>

<style lang="scss" scoped>


</style>
